export default __webpack_public_path__ + "images/a6f0ad9a7766e8ecf9eeb11facfb6ab3-hightech_small.webp";